import PropTypes from 'prop-types';
import React, { Component } from 'react';

require("./Lightbox.scss");

export class Lightbox extends Component {
  static propTypes = {
    data: PropTypes.object,
    disableOverlayClose: PropTypes.bool,
    disableEscClose: PropTypes.bool,
    children: PropTypes.node,
    close: PropTypes.func.isRequired,
    title: PropTypes.string
  }

  constructor(...args) {
    super(...args);

    this.state = {
      disableOverlayClose: this.props.disableOverlayClose
    }
  }

  componentWillReceiveProps(nextProps) {
    const {disableOverlayClose: next} = nextProps;
    const {disableOverlayClose: current} = this.props;

    if (next !== current) {
      if (next) { // disable immediately
        this.setState({disableOverlayClose: true});
      }
      else { // enable after a short delay, to allow for use on a blur event
        this.timeout = window.setTimeout(() => this.setState({disableOverlayClose: false}), 100);
      }
    }
  }

  componentWillMount() {
    // stop bg behind overlay being scrollable
    document.querySelector("body").classList.add("no-scroll");
    // allow escape to hide lb
    this.closeLb = evt => {
      if (!this.props.disableEscClose && (evt.key === "Escape" || evt.keyCode === 27)) {
        this.props.close();
      }
    };
    this.escapeEventHandler = document.addEventListener('keyup', this.closeLb);
  }

  componentWillUnmount() {
    document.querySelector("body").classList.remove("no-scroll");

    // unbind keyup event
    document.removeEventListener('keyup', this.closeLb);

    // clear any pending timeout for enabling overlay clicks
    window.clearTimeout(this.timeout);
  }

  overlayClick() {
    if (!this.state.disableOverlayClose) {
      this.closeLightbox();
    }
  }

  closeLightbox = () => {
    this.props.close();
  }

  render() {
    return (
      <div className="lb-container">
        <div className="lb-bg-overlay" onClick={() => this.overlayClick()} />
        <div className="lb" id="lb">
          <div className="lb-title">
            <span>{this.props.title}</span>
            <a className="lb-close" onClick={() => this.closeLightbox()}>&times;</a>
          </div>
          <div className="lb-content">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/Lightbox.js